function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export function fund() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    homeStatus: '',
    fund: {
      model: {},
      fetching: false,
      fetched: false,
      request: {},
      notFound: false
    },
    funds: [],
    questions: [],
    advisors: [],
    macrocategories: [],
    categories: [],
    category: {
      model: null,
      fetching: false,
      fetched: false
    },
    managementCompanies: [],
    managementCompany: {
      model: {},
      fetching: false,
      fetched: false,
      request: {},
      notFound: false
    },
    sameManagementCompanyFunds: [],
    filters: {
      category: [],
      company: [],
      srri: [],
      country: [],
      order: null
    },
    fundList: {
      page: 1,
      fetched: false,
      fetching: false,
      items: [],
      paging: {}
    },
    countries: [{
      id: 'esp',
      name: 'Nacional'
    }],
    topGlobalFunds: [],
    topLocalFunds: [],
    mostViewed: {
      page: 1,
      fetching: false,
      items: [],
      paging: {},
      request: {}
    },
    fundsByYTD: {
      page: 1,
      fetching: false,
      items: [],
      paging: {},
      request: {}
    },
    fundsByAssets: {
      page: 1,
      fetching: false,
      items: [],
      paging: {},
      request: {}
    },
    companies: {
      page: 1,
      fetching: false,
      items: [],
      paging: {},
      request: {}
    },
    fundsByManagementCompany: {
      page: 1,
      fetching: false,
      fetched: false,
      items: [],
      paging: {},
      request: {}
    },
    fundsByCategory: {
      page: 1,
      fetching: false,
      fetched: false,
      items: [],
      paging: {},
      request: {}
    },
    distributors: {
      page: 1,
      fetching: false,
      fetched: false,
      items: [],
      paging: {},
      request: {}
    }
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_FUND_HOME_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.homeStatus = action.status;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ADVISORS':
      {
        const newState = _objectSpread({}, state);
        newState.advisors = [...action.advisors];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUND_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fund.fetching = action.fetching;
        newState.fund.fetched = action.fetched;
        newState.fund.notFound = action.notFound;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUND':
      {
        const newState = _objectSpread({}, state);
        newState.fund.model = _objectSpread({}, action.fund);
        newState.fund.fetching = false;
        newState.fund.fetched = true;
        newState.fund.notFound = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_FUND':
      {
        const newState = _objectSpread({}, state);
        newState.fund = {
          model: {},
          fetching: false,
          fetched: false,
          request: {},
          notFound: false
        };
        newState.advisors = [];
        newState.sameManagementCompanyFunds = [];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_TOP_LOCAL_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.topLocalFunds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_TOP_GLOBAL_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.topGlobalFunds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MACROCATEGORIES':
      {
        const newState = _objectSpread({}, state);
        newState.macrocategories = [...action.macrocategories];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_CATEGORIES':
      {
        const newState = _objectSpread({}, state);
        newState.categories = [...action.categories];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_CATEGORY_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.category = _objectSpread(_objectSpread({}, newState.category), {}, {
          fetching: action.fetching,
          fetched: action.fetched
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_CATEGORY':
      {
        const newState = _objectSpread({}, state);
        newState.category = _objectSpread(_objectSpread({}, newState.category), {}, {
          model: action.category,
          fetching: false,
          fetched: true
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_CATEGORY_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_CATEGORY':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [];
        newState.category = {
          model: null,
          fetching: false,
          fetched: false
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANIES':
      {
        const newState = _objectSpread({}, state);
        newState.managementCompanies = [...action.managementCompanies];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANIES_WITH_FILTER':
      {
        const newState = _objectSpread({}, state);
        newState.companies = {
          items: [...action.items]
        };
        newState.companies.fetching = false;
        newState.companies.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANIES_WITH_FILTER_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.companies.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANY':
      {
        const newState = _objectSpread({}, state);
        newState.managementCompany.model = _objectSpread({}, action.managementCompany);
        newState.managementCompany.fetching = false;
        newState.managementCompany.fetched = true;
        newState.managementCompany.notFound = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANY_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.managementCompany.fetching = action.fetching;
        newState.managementCompany.fetched = action.fetched;
        newState.managementCompany.notFound = action.notFound;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANAGEMENT_COMPANY_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_MANAGEMENT_COMPANY':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [];
        newState.managementCompany.model = {};
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_SAME_MANAGEMENT_COMPANY_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.sameManagementCompanyFunds = [...action.funds];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUND_LIST_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fundList.fetching = action.fetching;
        newState.fundList.fetched = action.fetched;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUND_LIST':
      {
        const newState = _objectSpread({}, state);
        newState.fundList = _objectSpread(_objectSpread({}, newState.fundList), {}, {
          items: [...action.items],
          paging: _objectSpread({}, action.paging),
          fetching: false,
          fetched: true
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'ADD_FUND_LIST':
      {
        const newState = _objectSpread({}, state);
        newState.fundList.items = [...newState.fundList.items, ...action.items];
        newState.fundList.fetching = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_FILTERS':
      {
        const newState = _objectSpread({}, state);
        newState.filters = _objectSpread({}, action.filters);
        newState.fundList.fetching = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'ADD_FUND_LIST_PAGE':
      {
        const newState = _objectSpread({}, state);
        newState.fundList.page = action.page;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_MOST_VIEWED':
      {
        const newState = _objectSpread({}, state);
        newState.mostViewed = {
          items: [...action.items]
        };
        newState.mostViewed.fetching = false;
        newState.mostViewed.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_MOST_VIEWED_FETCHING':
      {
        const newState = _objectSpread({}, state);
        newState.mostViewed.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_YTD':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByYTD = {
          items: [...action.items]
        };
        newState.fundsByYTD.fetching = false;
        newState.fundsByYTD.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_ASSETS':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByAssets = {
          items: [...action.items]
        };
        newState.fundsByAssets.fetching = false;
        newState.fundsByAssets.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_YTD_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByYTD.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_ASSETS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByAssets.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_MANGEMENT_COMPANY_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByManagementCompany.fetching = action.fetching;
        newState.fundsByManagementCompany.fetched = action.fetched;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_MANGEMENT_COMPANY':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByManagementCompany = {
          items: [...action.items],
          paging: _objectSpread({}, action.paging)
        };
        newState.fundsByManagementCompany.fetched = true;
        newState.fundsByManagementCompany.page = action.request.page;
        newState.fundsByManagementCompany.fetching = false;
        newState.fundsByManagementCompany.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_CATEGORY_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByCategory.fetching = action.fetching;
        newState.fundsByCategory.fetched = action.fetched;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_FUNDS_BY_CATEGORY':
      {
        const newState = _objectSpread({}, state);
        newState.fundsByCategory = {
          items: [...action.items],
          paging: _objectSpread({}, action.paging)
        };
        newState.fundsByCategory.fetched = true;
        newState.fundsByCategory.fetching = false;
        newState.fundsByCategory.page = action.request.page;
        newState.fundsByCategory.request = action.request;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    default:
      return state;
  }
}